module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[],"language":"en","titleTemplate":"%s | Omega Agencia de Viajes","openGraph":{"type":"website","locale":"es_VE","url":"https://omega-agencia.netlify.app","site_name":"Omega Agencia de Viajes","images":[{"url":"/static/omega-site.png","width":1200,"height":900,"alt":"Viajes Omega"}]},"twitter":{"handle":"@viajesomega","site":"https://twitter.com/viajesomega?lang=es","cardType":"summary_large_image"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
